import discussion from './discussion'

export default discussion
